/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StudentSkillsMapSubstrandProficiencyIndicator_student = {
    readonly selfReportedGrade: {
        readonly order: number;
    };
    readonly " $refType": "StudentSkillsMapSubstrandProficiencyIndicator_student";
};
export type StudentSkillsMapSubstrandProficiencyIndicator_student$data = StudentSkillsMapSubstrandProficiencyIndicator_student;
export type StudentSkillsMapSubstrandProficiencyIndicator_student$key = {
    readonly " $data"?: StudentSkillsMapSubstrandProficiencyIndicator_student$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StudentSkillsMapSubstrandProficiencyIndicator_student">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StudentSkillsMapSubstrandProficiencyIndicator_student",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LanternGrade",
      "kind": "LinkedField",
      "name": "selfReportedGrade",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LanternStudent",
  "abstractKey": null
};
(node as any).hash = '42ba256b257080187ead501092b7b3d1';
export default node;
